<template>
    <router-view></router-view>
</template>
<script>
export default {
    name: 'daily',

}
</script>
<style lang="scss" scoped>
</style>